function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.946,
    height: 24,
    viewBox: "0 0 88.946 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "mob logo final"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2506",
    d: "M419.292 163a3.292 3.292 0 0 1 3.292 3.292 3.292 3.292 0 0 1-3.292 3.292 3.292 3.292 0 0 1-3.292-3.292 3.292 3.292 0 0 1 3.292-3.292z",
    transform: "translate(-350.882 -145.74)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2507",
    d: "M419.292 108a3.292 3.292 0 0 1 3.292 3.292 3.292 3.292 0 0 1-3.292 3.292 3.292 3.292 0 0 1-3.292-3.292 3.292 3.292 0 0 1 3.292-3.292z",
    transform: "translate(-350.882 -99.362)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2508",
    d: "M419.292 53a3.292 3.292 0 0 1 3.292 3.292 3.292 3.292 0 0 1-3.292 3.292A3.292 3.292 0 0 1 416 56.292 3.292 3.292 0 0 1 419.292 53z",
    transform: "translate(-350.882 -52.984)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2509",
    d: "M474.292 163a3.292 3.292 0 0 1 3.292 3.292 3.292 3.292 0 0 1-3.292 3.292 3.292 3.292 0 0 1-3.292-3.292 3.292 3.292 0 0 1 3.292-3.292z",
    transform: "translate(-397.26 -145.74)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2510",
    d: "M474.292 108a3.292 3.292 0 0 1 3.292 3.292 3.292 3.292 0 0 1-3.292 3.292 3.292 3.292 0 0 1-3.292-3.292 3.292 3.292 0 0 1 3.292-3.292z",
    transform: "translate(-397.26 -99.362)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2511",
    d: "M474.292 53a3.292 3.292 0 0 1 3.292 3.292 3.292 3.292 0 0 1-3.292 3.292A3.292 3.292 0 0 1 471 56.292 3.292 3.292 0 0 1 474.292 53z",
    transform: "translate(-397.26 -52.984)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2512",
    d: "M529.292 108a3.292 3.292 0 0 1 3.292 3.292 3.292 3.292 0 0 1-3.292 3.292 3.292 3.292 0 0 1-3.292-3.292 3.292 3.292 0 0 1 3.292-3.292z",
    transform: "translate(-443.638 -99.362)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M292.617 64.391a8.874 8.874 0 0 0-1.85-2.853 8.18 8.18 0 0 0-2.759-1.865 8.351 8.351 0 0 0-3.37-.674 6.58 6.58 0 0 0-1.207.125 8.086 8.086 0 0 0-1.207.329 5.923 5.923 0 0 0-1.082.564 3.988 3.988 0 0 0-.831.784V52.9H276v15.065a9.345 9.345 0 0 0 .674 3.605 8.9 8.9 0 0 0 1.85 2.822 8.539 8.539 0 0 0 2.759 1.85 8.671 8.671 0 0 0 3.37.658 8.9 8.9 0 0 0 3.37-.643 8.455 8.455 0 0 0 2.759-1.818 8.636 8.636 0 0 0 1.85-2.837 9.394 9.394 0 0 0 .674-3.637 9.137 9.137 0 0 0-.689-3.574zm-4.017 5.392a4.369 4.369 0 0 1-.925 1.458 4.616 4.616 0 0 1-1.379.988 3.945 3.945 0 0 1-1.662.345 4.069 4.069 0 0 1-1.677-.345 4.226 4.226 0 0 1-1.364-.988 4.631 4.631 0 0 1-.925-1.458 4.933 4.933 0 0 1-.329-1.818 4.54 4.54 0 0 1 .329-1.709 4.8 4.8 0 0 1 2.289-2.508 3.664 3.664 0 0 1 1.677-.392 3.945 3.945 0 0 1 1.662.345 4.082 4.082 0 0 1 1.379.972 4.707 4.707 0 0 1 .925 1.474 4.966 4.966 0 0 1 0 3.637z",
    transform: "translate(-232.828 -52.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.282 94.261a8.06 8.06 0 0 0-2.759-1.818 8.605 8.605 0 0 0-3.37-.643 8.4 8.4 0 0 0-3.37.674 8.8 8.8 0 0 0-2.759 1.881 8.636 8.636 0 0 0-1.85 2.837 9.243 9.243 0 0 0-.674 3.574 9.141 9.141 0 0 0 .674 3.543 8.975 8.975 0 0 0 1.85 2.837 9.16 9.16 0 0 0 2.759 1.881 8.763 8.763 0 0 0 6.741 0 9.16 9.16 0 0 0 2.759-1.881 8.8 8.8 0 0 0 1.85-2.837 9.141 9.141 0 0 0 .674-3.543 9.5 9.5 0 0 0-.674-3.668 8.476 8.476 0 0 0-1.851-2.837zm-2.163 8.387a4.37 4.37 0 0 1-.925 1.458 4.2 4.2 0 0 1-3.041 1.27 4.069 4.069 0 0 1-1.677-.345 4.226 4.226 0 0 1-1.364-.988 4.739 4.739 0 0 1-1.238-3.276 5.151 5.151 0 0 1 .329-1.881 4.334 4.334 0 0 1 .909-1.458 4.089 4.089 0 0 1 1.364-.941 4.325 4.325 0 0 1 1.677-.329 4.192 4.192 0 0 1 1.662.329 3.612 3.612 0 0 1 1.379.941 4.632 4.632 0 0 1 .925 1.458 5.3 5.3 0 0 1 0 3.762z",
    transform: "translate(-128.688 -85.702)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9 111.244V100.49a2.065 2.065 0 0 1 .157-.831 2.114 2.114 0 0 1 .455-.69 1.9 1.9 0 0 1 .674-.455 2.19 2.19 0 0 1 .831-.172 2.072 2.072 0 0 1 .831.172 1.892 1.892 0 0 1 .69.455 1.957 1.957 0 0 1 .455.69 2.19 2.19 0 0 1 .172.831v10.754h4.327V100.49a2.065 2.065 0 0 1 .157-.831 2.114 2.114 0 0 1 .455-.69 1.9 1.9 0 0 1 .674-.455 2.19 2.19 0 0 1 .831-.172 2.072 2.072 0 0 1 .831.172 1.892 1.892 0 0 1 .69.455 1.957 1.957 0 0 1 .455.69 2.19 2.19 0 0 1 .172.831v10.754h4.389v-10.613a7.209 7.209 0 0 0-3.4-5.863 5.922 5.922 0 0 0-.549-.266A6.13 6.13 0 0 0 15.68 94a6.241 6.241 0 0 0-1.191.11 5.259 5.259 0 0 0-1.176.329 5.2 5.2 0 0 0-1.066.611 4.245 4.245 0 0 0-.909.925 4.764 4.764 0 0 0-1.991-1.536 6.25 6.25 0 0 0-4.562-.016 6.918 6.918 0 0 0-1.662.925A7.237 7.237 0 0 0 .6 99.847v11.4z",
    transform: "translate(-.6 -87.557)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1a9cbcfd4a80f4dae88e50c943146c0a.svg";
export { ForwardRef as ReactComponent };